module.exports = __webpack_public_path__ + "img/send-mail.1bd3df5a.svg";